import './App.css';
import Routing from './components/routing'

function App() {
  return (
    <div className="App">
      <Routing />
    </div>
  );
}

export default App;
